/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_DeclineInputs */

const th_meeting_decline = /** @type {(inputs: Meeting_DeclineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปฏิเสธ`)
};

const en_meeting_decline = /** @type {(inputs: Meeting_DeclineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decline`)
};

const ja_meeting_decline = /** @type {(inputs: Meeting_DeclineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`辞退する`)
};

const zh_meeting_decline = /** @type {(inputs: Meeting_DeclineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`拒绝`)
};

const es_meeting_decline = /** @type {(inputs: Meeting_DeclineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechazar`)
};

const pt_meeting_decline = /** @type {(inputs: Meeting_DeclineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recusar`)
};

const id_meeting_decline = /** @type {(inputs: Meeting_DeclineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tolak`)
};

const fr_meeting_decline = /** @type {(inputs: Meeting_DeclineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refuser`)
};

const tl_meeting_decline = /** @type {(inputs: Meeting_DeclineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tumanggi`)
};

const vi_meeting_decline = /** @type {(inputs: Meeting_DeclineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Từ chối`)
};

const ko_meeting_decline = /** @type {(inputs: Meeting_DeclineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`거절`)
};

const de_meeting_decline = /** @type {(inputs: Meeting_DeclineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Absagen`)
};

const ru_meeting_decline = /** @type {(inputs: Meeting_DeclineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отказаться`)
};

const tr_meeting_decline = /** @type {(inputs: Meeting_DeclineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reddet`)
};

const it_meeting_decline = /** @type {(inputs: Meeting_DeclineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rifiuta`)
};

const pl_meeting_decline = /** @type {(inputs: Meeting_DeclineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odmów`)
};

const uk_meeting_decline = /** @type {(inputs: Meeting_DeclineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Відхилити`)
};

const hi_meeting_decline = /** @type {(inputs: Meeting_DeclineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अस्वीकार करें`)
};

const ar_meeting_decline = /** @type {(inputs: Meeting_DeclineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رفض`)
};

const ms_meeting_decline = /** @type {(inputs: Meeting_DeclineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tolak`)
};

const bn_meeting_decline = /** @type {(inputs: Meeting_DeclineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রত্যাখ্যান`)
};

const zh_tw2_meeting_decline = /** @type {(inputs: Meeting_DeclineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`婉拒`)
};

const zh_hk2_meeting_decline = /** @type {(inputs: Meeting_DeclineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`婉拒`)
};

const ur_meeting_decline = /** @type {(inputs: Meeting_DeclineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`انکار کریں`)
};

const fa_meeting_decline = /** @type {(inputs: Meeting_DeclineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رد کردن`)
};

const sw_meeting_decline = /** @type {(inputs: Meeting_DeclineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kataa`)
};

const nl_meeting_decline = /** @type {(inputs: Meeting_DeclineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afwijzen`)
};

/**
* | output |
* | --- |
* | "Decline" |
*
* @param {Meeting_DeclineInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const meeting_decline = /** @type {((inputs?: Meeting_DeclineInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_DeclineInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_meeting_decline(inputs)
	if (locale === "ja") return ja_meeting_decline(inputs)
	if (locale === "zh") return zh_meeting_decline(inputs)
	if (locale === "es") return es_meeting_decline(inputs)
	if (locale === "pt") return pt_meeting_decline(inputs)
	if (locale === "id") return id_meeting_decline(inputs)
	if (locale === "fr") return fr_meeting_decline(inputs)
	if (locale === "tl") return tl_meeting_decline(inputs)
	if (locale === "vi") return vi_meeting_decline(inputs)
	if (locale === "ko") return ko_meeting_decline(inputs)
	if (locale === "de") return de_meeting_decline(inputs)
	if (locale === "ru") return ru_meeting_decline(inputs)
	if (locale === "tr") return tr_meeting_decline(inputs)
	if (locale === "it") return it_meeting_decline(inputs)
	if (locale === "pl") return pl_meeting_decline(inputs)
	if (locale === "uk") return uk_meeting_decline(inputs)
	if (locale === "hi") return hi_meeting_decline(inputs)
	if (locale === "ar") return ar_meeting_decline(inputs)
	if (locale === "ms") return ms_meeting_decline(inputs)
	if (locale === "bn") return bn_meeting_decline(inputs)
	if (locale === "zh-TW") return zh_tw2_meeting_decline(inputs)
	if (locale === "zh-HK") return zh_hk2_meeting_decline(inputs)
	if (locale === "ur") return ur_meeting_decline(inputs)
	if (locale === "fa") return fa_meeting_decline(inputs)
	if (locale === "sw") return sw_meeting_decline(inputs)
	if (locale === "nl") return nl_meeting_decline(inputs)
	return en_meeting_decline(inputs)
});